import type { JSX, ReactNode } from 'react';

import AntdProvider from './AntdProvider';

import { ThemeProvider } from './ThemeProvider';

interface GlobalProviderProps {
  children: ReactNode;
  locale: string;
  theme?: 'light' | 'dark' | 'system';
}

function GlobalProvider({ children, theme }: GlobalProviderProps): JSX.Element | null {
  return (
    <AntdProvider>
      <ThemeProvider defaultTheme={theme} storageKey="rubidex-theme">
        {children}
      </ThemeProvider>
    </AntdProvider>
  );
}

export default GlobalProvider;
